<template>
  <div
    class="public-layout"
    :class="[
      {
        'is-detail': isDetail,
      },
      ui?.root,
    ]"
  >
    <SPBreadcrumbs
      v-if="breadcrumbsInTop && breadcrumbs"
      :breadcrumbs="breadcrumbs"
      :class="ui?.topBreadcrumbs"
      data-slot="top-breadcrumbs"
    />
    <SPPageTop
      :variant="variant"
      :hero="hero"
      :ui="{
        directions: ui?.directions,
      }"
      @search="emit('search', $event)"
    >
      <template v-if="hero && breadcrumbs" #hero-breadcrumbs>
        <slot name="hero-breadcrumbs">
          <SPBreadcrumbs
            :breadcrumbs="breadcrumbs"
            :class="ui.heroBreadcrumbs"
            data-slot="hero-breadcrumbs"
          />
        </slot>
      </template>

      <template #hero-title>
        <slot name="hero-title" />
      </template>
      <template #hero-description>
        <slot name="hero-description" />
      </template>
      <template v-if="$slots['hero-search']" #hero-search>
        <slot name="hero-search" />
      </template>
      <template v-if="$slots['hero-directions']" #hero-directions>
        <slot name="hero-directions" />
      </template>
    </SPPageTop>

    <UContainer>
      <SPBreadcrumbs
        v-if="breadcrumbsInContent"
        :breadcrumbs="breadcrumbs"
        :hero="false"
        :class="ui.contentBreadcrumbs"
        data-slot="content-breadcrumbs"
      />
    </UContainer>

    <main class="page-main" :class="ui?.main" data-slot="main">
      <slot>
        <NuxtPage />
      </slot>
    </main>

    <SPFeedback />
    <SPFooter />
  </div>
</template>

<script setup lang="ts">
import type { BreadcrumbItem, PageVariant } from '~/types'

defineOptions({
  name: 'PublicLayout',
})

const emit = defineEmits<{
  search: [value: string]
}>()

withDefaults(
  defineProps<{
    variant?: PageVariant
    hero?: boolean
    breadcrumbsInTop?: boolean
    breadcrumbsInContent?: boolean
    ui?: {
      root?: string
      main?: string
      topBreadcrumbs?: string
      heroBreadcrumbs?: string
      contentBreadcrumbs?: string
      directions?: string
    }
  }>(),
  {
    variant: 'main',
    hero: true,
    breadcrumbsInTop: false,
    breadcrumbsInContent: false,
    ui: () => ({}),
  },
)

const route = useRoute()
const breadcrumbs = computed<BreadcrumbItem[] | undefined>(
  () => route.meta.breadcrumbs,
)

const isDetail = computed(() => (route.name as string)?.includes('id'))
</script>

<style lang="scss" scoped>
.public-layout {
  background-color: var(--color-background-bg1);
  min-height: 100dvh;
}

.page-main {
  padding-bottom: var(--page-section-padding);
}
</style>
